import { Box, Image, Text, TextInput } from '@jfs/ui-new'
import sort_decreasing from '../../assets/images/Decreasing.png'
import sort_increasing from '../../assets/images/Increasing.png'
import sort_inactive from '../../assets/images/sort_inactive.png'
import { amountColumns } from '../../data/static/data'

const getSortImage = (direction: string) => {
  const getImage: any = {
    ['DESC']: sort_decreasing,
    ['ASC']: sort_increasing,
    ['NONE']: sort_inactive,
  }
  return getImage[direction] ?? getImage.NONE
}

const CustomHeaderRenderer = ({
  label,
  styles,
  sortBy,
  sortDirection = 'ASC',
  isColumnSearchEnabled,
  onSearchTextChange,
  headerRowKeys,
}: any) => {
  const showSortIndicator = sortBy === label

  const handleColumnSearch = (searchText: string) => {
    if (onSearchTextChange) {
      onSearchTextChange(label, searchText)
    }
  }
  const isAmountColumn = amountColumns.includes(label)
  return (
    <Box flexDirection={'column'}>
      <Box {...styles.titleheaderView} justify={isAmountColumn ? 'center': 'flex-start'}>
        <Text {...styles.titleHeader} textAlign={isAmountColumn ? 'right' : 'left'}>{headerRowKeys[label] ?? label}</Text>
        {showSortIndicator && (
          <Box paddingLeft={4}>
            <Image source={getSortImage(sortDirection)} width={16} height={16} />
          </Box>
        )}
      </Box>
      {isColumnSearchEnabled && label !== 'check' && (
        <TextInput
          placeholderTextColor={'BLACK'}
          onChangeText={handleColumnSearch}
          fontSize={12}
          fontWeight={'300'}
          fontFamily={'jiotype-medium'}
        />
      )}
    </Box>
  )
}

export { CustomHeaderRenderer }
